import styled from 'styled-components';
import { Link } from 'react-router-dom';
import AppCSS from '../../../utils/styled';
import Button from '@mui/material/Button';

export const Components = {
  Container: styled.div`
    padding: 12px 0;
    max-height: 500px;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  `,

  Header: styled.div`
    ${AppCSS.fonts.h2};
    margin-top: 24px;
    margin-bottom: 50px;
    gap: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,

  Title: styled.span`
    ${AppCSS.fonts.h2};
    text-align: center;
  `,

  CheckboxContainer: styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    align-self: center;
  `,

  CheckboxWrapper: styled.div`
    display: flex;
    justify-content: flex-start;
  `,

  CheckboxText: styled.span`
    ${AppCSS.fonts.label14Medium};
    display: flex;
    align-self: center;
  `,

  Border: styled.div`
    border-bottom: 1px solid;
    border-color: ${AppCSS.colors.white};
    margin-top: 16px;
  `,

  InfoText: styled.span`
    margin-top: 24px;
    ${AppCSS.fonts.label16Medium};
    color: ${AppCSS.colors.blues.dark};
    text-align: center;
  `,

  Link: styled(Link)`
    ${AppCSS.fonts.label16Bold};
    color: ${AppCSS.colors.blues.strong};
    text-decoration-line: underline;
    cursor: pointer;
  `,

  CloseIconWrapper: styled.div`
    &:hover {
      cursor: pointer;
    }
  `,

  Button: styled(Button)<{ isDisabled?: boolean }>`
    ${(p) =>
      p?.isDisabled
        ? `background-color: ${AppCSS.colors.blues.light};`
        : `background-color: ${AppCSS.colors.blues.strong};`}
    ${AppCSS.radiuses.rounded};
    padding: 12px 0;
    text-transform: none;
    &:hover {
      ${(p) =>
        p?.isDisabled
          ? `background-color: ${AppCSS.colors.blues.light};`
          : `background-color: ${AppCSS.colors.blues.strong};`}
    }
  `,

  ButtonText: styled.span`
    color: ${AppCSS.colors.blues.veryDark};
    ${AppCSS.fonts.label12Bold};
    padding: 0 48px;
  `,

  Item: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  `,

  ItemTitle: styled.span`
    ${AppCSS.fonts.label16Bold};
    color: ${AppCSS.colors.blues.dark};
  `,

  ItemDescription: styled.span`
    ${AppCSS.fonts.paragraph14Regular};
    color: ${AppCSS.colors.blues.dark};
  `,
  List: styled.ul`
    margin-top: -4px;
    margin-left: 0;
    padding-left: 18px;
  `,
  ListItem: styled.li`
    list-style-type: circle;
  `,
};
